export const envs =  {
  development:{
    NODE_ENV: 'development',
    API_ENDPOINT: 'http://localhost:3201',
    Client_ID: "1064484345544-q306hi1qda8u6da41427d2i4mbs1niej.apps.googleusercontent.com",
  },
  production:{
    NODE_ENV: 'production',
    API_ENDPOINT:window.location.origin,
    Client_ID: "1064484345544-q306hi1qda8u6da41427d2i4mbs1niej.apps.googleusercontent.com",
  }
}



// WEBPACK FOOTER //
// ./src/store/All.env.js